<template>
  <div class="emap-flow-modal-changeAssignee">
    <van-popup v-model="groupVisible" position="bottom" get-container="body" :style="{ width: '100%'}" v-if="options.groups && users.length || isMultiInstance">
      <van-nav-bar
        :title="isMultiInstance ? '转办用户组' : '转办他人'"
        left-text="取消"
        right-text="确定"
        @click-left="groupVisible = false"
        @click-right="onGroupConfirm"
      />
      <van-radio-group v-model="group" v-if="isMultiInstance">
        <van-cell-group class="radio-group-container">
          <van-cell v-for="(item, index) in groups" clickable :key="index" class="van-cell-offset">
            <van-radio :name="item.id">
              <template slot="props"><i></i></template>
              {{ item.name }}
            </van-radio>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-radio-group v-model="user" v-else>
        <van-cell-group class="radio-group-container">
          <van-cell v-for="(item, index) in users" clickable :key="index" class="van-cell-offset">
            <van-radio :name="item.userId">
              <template slot="props"><i></i></template>
              {{item.userName}}
            </van-radio>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
    <emap-flow-pick-m v-model="visible"  @on-confirm="onConfirm" v-if="!options.groups || emptyUsers"></emap-flow-pick-m>
  </div>
</template>
<script>
import EmapFlowPickM from '../emap-flow-pick-m.vue'
import { queryCurNodeInfo, queryTurnGroupUsers, queryMultiInstanceGroups } from '@/api/toolbar'

export default {
  name: "change-assignee",
  components: {
    EmapFlowPickM
  },
  data() {
    return {
      visible: false,
      groupVisible: false,
      emptyUsers: false,
      user: '',
      users: [],
      isMultiInstance: void 0, // 功能废弃
      group: [],
      groups: []
    }
  },
  props: {
    value: Boolean,
    options: Object,
    taskid: String,
    defkey: String
  },
  watch: {
    value(val) {
      if(val) {
        this.doVisible()
      }
    },
    groupVisible(val) {
      if(!val) this.$emit('input', false);
    },
    visible(val) {
      if(!val) this.$emit('input', false);
    },
  },
  methods: {
    doVisible() {
      if(this.isMultiInstance) {
        this.groupVisible = true
        this.getMultiInstanceGroup()
      } else {
        if(this.options.groups && !this.emptyUsers && !this.users.length) {
          this.getUsers().then(data => {
            this.users = data || []
            if(this.users.length) {
              this.groupVisible = true
            } else {
              this.emptyUsers = true
              this.visible = true
            }
          })
        } else {
          if(this.users.length) {
            this.groupVisible = true
          } else {
            this.visible = true;
          }
        }
      }
    },
    onGroupConfirm() {
      this.$emit('on-confirm', this.isMultiInstance ? this.group : this.user);
      this.groupVisible = false;
    },
    onConfirm(id) {
      this.$emit('on-confirm', id);
      this.visible = false;
    },
    getUsers() {
      queryTurnGroupUsers({groups: this.options.groups}).then(data => {
        if(data && data.items) {
          if(data.items.changeAssignees && data.items.changeAssignees.length) {
            this.groupVisible = true;
            this.users = data.items.changeAssignees;
          } else {
            this.emptyUsers = true;
            this.visible = true;
          }
        } else {
          console.error("获取转办用户组人员信息失败");
        }
      });
    },
    getMultiInstanceGroup() {
      queryMultiInstanceGroups({ defKey: this.defkey }).then(data => {
        if(data) {
          this.groups = data.map(item => {
            item.id = "group(" +  item.id + ")"
            return item
          })
        } else {
          console.error("获取用户组信息失败")
        }
      })
    },
    async getCurNodeInfo() {
      let result = await queryCurNodeInfo({taskId: this.taskid}).then(data => {
        if(data && data.currentNodes && data.currentNodes[0]) {
          return data.currentNodes[0].isGroupMultiInstance
        } else {
          console.error("获取当前节点信息失败")
        }
      })

      return result
    }
  }
};
</script>
<style scoped>
.radio-group-container {
  max-height: 300px;
  overflow:auto;
}
.van-cell-offset {
  font-size: 16px;
  line-height: 22px;
  padding: 15px 17px;
  color: #191919;
}
</style>